"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressVo = exports.countriesListNameToIso2 = exports.countriesListIsoToFullName = exports.countriesListIso2ToId = void 0;
const uuid_1 = require("uuid");
const addresses_1 = require("../../exceptions/addresses");
const countriesList_1 = require("./countriesList");
Object.defineProperty(exports, "countriesListNameToIso2", { enumerable: true, get: function () { return countriesList_1.countriesListNameToIso2; } });
Object.defineProperty(exports, "countriesListIsoToFullName", { enumerable: true, get: function () { return countriesList_1.countriesListIsoToFullName; } });
Object.defineProperty(exports, "countriesListIso2ToId", { enumerable: true, get: function () { return countriesList_1.countriesListIso2ToId; } });
const statesList_1 = require("./statesList");
class AddressVo {
    constructor(separator, version) {
        this._separator = '%%%';
        this._version = 'v01';
        this._separator = separator;
        this._version = version;
        this.uid = (0, uuid_1.v4)();
        this.firstName = '';
        this.lastName = '';
        this._country = 'United States of America';
        this.zipCode = '';
        this._state = '';
        this.city = '';
        this.address1 = '';
        this.address2 = '';
    }
    isValid() {
        return !!this.uid && !!this.firstName && !!this.lastName && !!this.country && !!this.zipCode && !!this.state && !!this.city && !!this.address1;
    }
    validate() {
        if (!this.uid)
            throw new addresses_1.BrokenAddressException('empty uid');
        if (!this.firstName)
            throw new addresses_1.BrokenAddressException('empty first name');
        if (!this.lastName)
            throw new addresses_1.BrokenAddressException('empty last name');
        if (!this.country)
            throw new addresses_1.BrokenAddressException('empty country');
        if (!this.zipCode)
            throw new addresses_1.BrokenAddressException('empty zip code');
        if (!this.state)
            throw new addresses_1.BrokenAddressException('empty state');
        if (!this.city)
            throw new addresses_1.BrokenAddressException('empty city');
        if (!this.address1)
            throw new addresses_1.BrokenAddressException('empty address');
    }
    static createV1() {
        return new AddressVo('%%%', 'v01');
    }
    static createEmptyBaseAddress() {
        const address = this.createV1();
        const emptyAddress = {
            uid: address.uid,
            firstName: address.firstName,
            lastName: address.lastName,
            address1: address.address1,
            address2: address.address2,
            city: address.city,
            state: address.state,
            zipCode: address.zipCode,
            country: address.country
        };
        return emptyAddress;
    }
    static createFromBaseAddress(source) {
        const newAddressVo = AddressVo.createV1();
        newAddressVo.uid = source.uid;
        newAddressVo.firstName = source.firstName;
        newAddressVo.lastName = source.lastName;
        newAddressVo.country = source.country;
        newAddressVo.zipCode = source.zipCode;
        newAddressVo.state = source.state;
        newAddressVo.city = source.city;
        newAddressVo.address1 = source.address1;
        newAddressVo.address2 = source.address2;
        return newAddressVo;
    }
    static createFromString(addressAsString) {
        // First three symbols in address defining the address string separator
        const separator = addressAsString.slice(0, 3);
        if (!separator) {
            throw new addresses_1.BrokenAddressException(`can't define separator in address ${addressAsString}`);
        }
        const version = addressAsString.slice(3, 6);
        if (!version) {
            throw new addresses_1.BrokenAddressException(`can't define version in address ${addressAsString}`);
        }
        const sourceAddress = addressAsString.slice(6, addressAsString.length);
        if (!sourceAddress) {
            throw new addresses_1.BrokenAddressException(`address is empty`);
        }
        const addressData = this.convertFromString(separator, version, sourceAddress);
        const newAddressVo = new AddressVo(separator, version);
        newAddressVo.uid = addressData.uid || '';
        newAddressVo.firstName = addressData.firstName || '';
        newAddressVo.lastName = addressData.lastName || '';
        newAddressVo.country = addressData.country || '';
        newAddressVo.zipCode = addressData.zipCode || '';
        newAddressVo.state = addressData.state || '';
        newAddressVo.city = addressData.city || '';
        newAddressVo.address1 = addressData.address1 || '';
        newAddressVo.address2 = addressData.address2 || '';
        return newAddressVo;
    }
    static createFromAddressModel(args) {
        const newAddress = this.createV1();
        newAddress.firstName = args.firstName;
        newAddress.lastName = args.lastName;
        newAddress.country = 'United States of America';
        newAddress.zipCode = args.zipCode;
        newAddress.state = args.state;
        newAddress.city = args.city;
        newAddress.address1 = args.address;
        newAddress.address2 = args.address2 || '';
        return newAddress;
    }
    static createFromAddressV2Dto(args) {
        const newAddress = this.createV1();
        newAddress.firstName = args.firstName;
        newAddress.lastName = args.lastName;
        newAddress.country = args.country;
        newAddress.zipCode = args.zipCode;
        newAddress.state = args.state;
        newAddress.city = args.city;
        newAddress.address1 = args.address;
        newAddress.address2 = args.address2;
        return newAddress;
    }
    static createFromShippingInfoV2(args) {
        const newAddress = this.createV1();
        newAddress.firstName = args.firstName;
        newAddress.lastName = args.lastName;
        newAddress.country = args.country;
        newAddress.zipCode = args.zipCode;
        newAddress.state = args.state;
        newAddress.city = args.city;
        newAddress.address1 = args.address;
        newAddress.address2 = args.address2;
        return newAddress;
    }
    convertToShippingInfoV2Dto(email, phone) {
        const newShippingInfoV2 = {
            firstName: this.firstName,
            lastName: this.lastName,
            email: email || '',
            phone: phone || '',
            zipCode: this.zipCode,
            country: this.country,
            state: this.state,
            city: this.city,
            address: this.address1,
            address2: this.address2
        };
        return newShippingInfoV2;
    }
    convertToCreateAddressV2Dto() {
        const newShippingInfoV2 = {
            firstName: this.firstName,
            lastName: this.lastName,
            zipCode: this.zipCode,
            country: this.country,
            state: this.state,
            city: this.city,
            address: this.address1,
            address2: this.address2
        };
        return newShippingInfoV2;
    }
    static createFromPublicAddressDto(addressAsDto) {
        const newAddress = this.createV1();
        newAddress.uid = addressAsDto.uid;
        newAddress.firstName = addressAsDto.firstName;
        newAddress.lastName = addressAsDto.lastName;
        newAddress.country = addressAsDto.country;
        newAddress.zipCode = addressAsDto.zipCode;
        newAddress.state = addressAsDto.state;
        newAddress.city = addressAsDto.city;
        newAddress.address1 = addressAsDto.address;
        newAddress.address2 = addressAsDto.address2;
        return newAddress;
    }
    getSafeString(source) {
        return source.replace(this._separator, ' ');
    }
    saveToString() {
        this.validate();
        switch (this._version) {
            case 'v01':
            default:
                // Address format for v1
                // [sep]v01UID[sep]FIRST_NAME[sep]LAST_NAME[sep]ADDRESS[sep]ADDRESS_2[sep]CITY[sep]STATE[sep]ZIP_CODE[sep]COUNTRY
                return `${this._separator}${this._version}${[
                    this.getSafeString(this.uid),
                    this.getSafeString(this.firstName),
                    this.getSafeString(this.lastName),
                    this.getSafeString(this.address1),
                    this.getSafeString(this.address2),
                    this.getSafeString(this.city),
                    this.getSafeString(this.state),
                    this.getSafeString(this.zipCode),
                    this.getSafeString(this.country)
                ].join(this._separator)}`;
        }
    }
    displayPreview() {
        return `${this.firstName} ${this.lastName}, ${this.address} ${this.address2}, ${this.city}, ${this.state}, ${this.zipCode}, ${this.country}`;
    }
    isPresentInList(listOfAddressesVo) {
        return listOfAddressesVo.some((item) => item.displayPreview() === this.displayPreview());
    }
    static convertFromString(separator, version, addressAsString) {
        switch (version) {
            case 'v01':
            default:
                return this.convertFromStringVersion01(separator, addressAsString);
        }
    }
    // Address format for v1
    // UID[sep]FIRST_NAME[sep]LAST_NAME[sep]ADDRESS[sep]ADDRESS_2[sep]CITY[sep]STATE[sep]ZIP_CODE[sep]COUNTRY
    static convertFromStringVersion01(separator, addressAsString) {
        const arrayOfFields = addressAsString.split(separator);
        if (arrayOfFields.length !== 9) {
            console.log('Wrong address', addressAsString);
            throw new addresses_1.BrokenAddressException(`wrong number of fields in version v01`);
        }
        const [uid, firstName, lastName, address1, address2, city, state, zipCode, country] = arrayOfFields;
        return {
            uid,
            firstName,
            lastName,
            address1,
            address2,
            city,
            state,
            zipCode,
            country
        };
    }
    get address() {
        return this.address2 ? `${this.address1} ${this.address2}` : this.address1;
    }
    get country() {
        return this._country;
    }
    set country(newCountryName) {
        const fixedCountryName = countriesList_1.countriesListIsoToFullName[newCountryName === null || newCountryName === void 0 ? void 0 : newCountryName.toLowerCase()];
        if (fixedCountryName) {
            this._country = fixedCountryName;
        }
        else {
            this._country = newCountryName;
        }
    }
    get countryId() {
        const countryId = countriesList_1.countriesListIso2ToId[this.countryIso2];
        return countryId;
    }
    get countryIso2() {
        const countryIso2 = countriesList_1.countriesListNameToIso2[this.country.toLowerCase()];
        return countryIso2;
    }
    get state() {
        return this._state;
    }
    set state(newStateName) {
        const fixedState = statesList_1.statesList[this.countryIso2][newStateName.toLowerCase()];
        if (fixedState) {
            this._state = fixedState.label;
        }
        else {
            this._state = newStateName;
        }
    }
    get stateIso2() {
        const regionInfo = statesList_1.statesList[this.countryIso2][this.state.toLowerCase()];
        if (!regionInfo)
            throw new addresses_1.WrongRegionException(this.state);
        return regionInfo.iso2;
    }
    get stateIso2Safe() {
        if (!this.countryIso2 || !this.state)
            return undefined;
        const regionInfo = statesList_1.statesList[this.countryIso2][this.state.toLowerCase()];
        return regionInfo.iso2;
    }
}
exports.AddressVo = AddressVo;
//# sourceMappingURL=index.js.map